import { Container, Grid } from "@mui/material";
import React, { useState } from "react";
import DfccCardImage from "../../../../styles/img/dfcc-card.png";
import { CloseIcon } from "../../../../styles/img/svg/CloseIcon";
import { useNavigate } from "react-router-dom";
import { BackIcon } from "../../../../styles/img/svg/BackIcon";
import { UiOnboardCreditCardDetailsForm } from "./forms/UiOnboardCreditCardDetailsForm";
import { UiProgressbar } from "../../component/_uiComponents/UiProgressbar";
import { UiDebitCreditCard } from "./UiDebitCreditCard";
import VisaLogo from "../../../../styles/img/visa-logo.png";
import MasterLogo from "../../../../styles/img/master-logo.png";
import VisaCreditLogo from "../../../../styles/img/visacredit-img.png";
import Logo from "../../../../styles/img/df-logo.png";

export const UiOnboardCreditCardDetails = () => {
  const [openModal, setOpenModal] = useState(false);

  const navigate = useNavigate();

  const backToHome = () => {
    navigate("/ui/dashboard");
  };

  const backToResetUsername = () => {
    navigate("/ui/ui-forget-username");
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <>
      <div className="df-logo-nav">
        <Container maxWidth="xl">
          <div className="df-logo-nav__content">
            <img src={Logo} />
          </div>
        </Container>
      </div>
      <div className="df-user-profile df-preset-card df-onboard-progress-back-close df-profile-top-aligned-box">
        <Container maxWidth="md" className="df-pos-rel">
          <div className="df-user-profile__close-icon" onClick={backToHome}>
            <CloseIcon />
          </div>

          <div className="df-user-profile__back-icon df-bc-w-progress">
            <UiProgressbar />

            <BackIcon onClick={backToHome} />
          </div>

          <div className="df-user-profile__body df-pw-tab df-card-details-tb">
            <Grid container>
              <Grid size={{ xs: 12, sm: 6, lg: 6, xl: 6 }}>
                <UiDebitCreditCard
                  cardType="creditcard"
                  onCardNumberSelect={false}
                  onExpireDateSelect={true}
                  cardTypeLogo={VisaLogo}
                />

                <h2 className="df-reset-pw-title text-center">
                  Enter your credit card details
                </h2>
              </Grid>

              <Grid
                size={{ xs: 12, sm: 6, lg: 6, xl: 6 }}
                className="text-right df-pl-2"
              >
                <UiOnboardCreditCardDetailsForm />
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>
    </>
  );
};
